export default __webpack_public_path__ + "static/media/cm.5bdaa610.svg";